export default __webpack_public_path__ + "static/media/Cattura11.5cda1f74.jpg";